import { createSlice } from "@reduxjs/toolkit";
import { allCategoriesAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const allCategoriesSlice = createSlice({
  name: "allCategories",
  initialState: data,
  reducers: {
    allCategoriesSlice(state) {
      state.isLoading = true;
    },
    allCategoriesSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    allCategoriesSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    allCategoriesSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const allCategoriesHandler = () => async (dispatch: any) => {
  try {
    dispatch(allCategoriesAction.allCategoriesSlice());
    const response: any = await allCategoriesAPI();
    dispatch(allCategoriesAction.allCategoriesSliceSuccess(response));
  } catch (e: any) {
    dispatch(allCategoriesAction.allCategoriesSliceFailure(e?.response?.data?.message));
    dispatch(allCategoriesAction.allCategoriesSliceReset());
  }
};
export default allCategoriesSlice.reducer;
export const allCategoriesAction = allCategoriesSlice.actions;
